export async function triggerProjectCoverPrerenderWebhookQuery(url) {
  await fetch(`${import.meta.env.APP_CHECK_PDF_URL}?url=${url}`);
}
